import {
  AppBar,
  Box,
  Divider,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Toolbar,
  Typography,
  useMediaQuery,
  CircularProgress
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FC } from "react";
import LogoNavBar from "../icons/logo-Ummia.png";
import ProfileMenu from "./ProfileMenu";
import { Link } from "react-router-dom";

import CreditosNavBar from "../../../components/Creditos/CreditosNavBar";
import RoleSelector from "../../../components/Navbar/RoleSelector";
import { useOrganizationContext } from "../../../context/OrganizationContext";

interface Props {
  handleDrawerToggle: () => void;
}

const Navbar: FC<Props> = ({ handleDrawerToggle }) => {
  const isMobile = useMediaQuery("(max-width:768px)");

  const {
    selectedOrgId,
    selectedOrgName,
    userOrganizations,
    isLoadingOrgs,
    switchOrganization,
  } = useOrganizationContext();

  const hasMultipleOrgs = userOrganizations.length > 1;

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#FCFCFC",
        color: "#2f2f2f",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.5)",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {/* Boton para abrir el menú en mobile */}
          {isMobile && (
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 1, color: "#336B87" }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Logo UmmIA */}
          <Link to="/asistente/menu">
            <Box
              component="img"
              src={LogoNavBar}
              alt="Logo"
              sx={{
                height: { xs: 35, md: 40, lg: 45 },
                width: { xs: 120, md: 130, lg: 140 },
                objectFit: "fit",
                cursor: "pointer",
                display: "flex",
              }}
            />
          </Link>
        </Box>

        {/* Menú de perfil */}
        <Box sx={{ display: "flex", alignItems: "center" }}>

          {/* Selector de organización */}
          {isLoadingOrgs ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography fontFamily="Montserrat" fontSize={12}>
                Organización:
              </Typography>
              <CircularProgress size={16} />
            </Stack>
          ) : hasMultipleOrgs ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography fontFamily="Montserrat" fontSize={12}>
                Organización:
              </Typography>
              <Select
                value={selectedOrgId || ""}
                onChange={(e) => { switchOrganization(e.target.value); }}
                size="small"
                sx={{
                  minWidth: 150,
                  fontFamily: "Montserrat",
                  fontSize: 12,
                  fontWeight: "bold",
                  color: "#336B87",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #336B87",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #336B87",
                  },
                }}
                renderValue={() => (
                  <Typography
                    fontWeight="bold"
                    fontSize={12}
                    fontFamily="Montserrat"
                    color="#336B87"
                  >
                    {selectedOrgName ?? selectedOrgId ?? ""}
                  </Typography>
                )}
              >
                {userOrganizations.map((org) => (
                  <MenuItem
                    key={org.id_organizacion}
                    value={org.id_organizacion}
                    disabled={org.disabled}
                    sx={{
                      fontFamily: "Montserrat",
                      fontSize: 12,
                    }}
                  >
                    <Typography fontSize={12} fontFamily="Montserrat">
                      {org.nombre_organizacion}
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
            </Stack>
          ) : (
            <Stack direction="row" spacing={1} sx={{ mr: 2 }}>
              <Typography fontFamily="Montserrat" fontSize={12}>
                Organización:
              </Typography>
              <Typography
                fontWeight="bold"
                fontSize={12}
                fontFamily="Montserrat"
                color="#336B87"
              >
                {selectedOrgName ?? selectedOrgId ?? ""}
              </Typography>
            </Stack>
          )}

          {/* Selector de roles */}
          <RoleSelector />

          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 2, borderColor: "#ccc", my: 1 }}
          />

          {/** Contenedor de Créditos */}
          <CreditosNavBar />
          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 2, borderColor: "#ccc", my: 1 }}
          />

          <ProfileMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
